import React from 'react';

import { MessageOptions } from '~/domain/interfaces/redux/message';
import {
  CancelBody,
  Container,
  ConfirmCancel,
  CloseButton,
  Header,
} from './styles/StyledExcludeMessage';

import { Button } from '../../UI';

import { ownProps } from '../interface';

import { translator } from '../../i18n';

const ScheduleExclude: React.FC<ownProps> = ({ message }) => {
  const msgName = MessageOptions.appointmentDelete;

  const { active, actionCancel, actionOk } = message;

  return (
    <>
      {msgName === active ? (
        <Container>
          <CancelBody>
            <Header>
              <span>{translator('Cancelar atendimento?')}</span>
              <CloseButton onClick={actionCancel}>X</CloseButton>
            </Header>
            <Button
              rounded
              variant="primary"
              size="large"
              onClick={actionOk}
              autoFocus
            >
              {translator('Não cancelar')}
            </Button>
            <ConfirmCancel>{translator('Sim, cancelar')}</ConfirmCancel>
          </CancelBody>
        </Container>
      ) : null}
    </>
  );
};

export default ScheduleExclude;
